export const fileExt = {
    pdf: 'application/pdf',
    xls: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
    png: 'image/png',
    jpg: 'image/jpeg',
    git: 'image/gif'
}
